export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_AVATAR = 'SET_AVATAR'
export const SET_USER_EXTRA_DATA = 'SET_USER_EXTRA_DATA'
export const SET_CREDITS = 'SET_CREDITS'
export const SET_USER_NOTIFICATION_CENTER_DATA =
  'SET_USER_NOTIFICATION_CENTER_DATA'
export const SET_USER_NOTIFICATION_CENTER_LOADING_STATE =
  'SET_USER_NOTIFICATION_CENTER_LOADING_STATE'
export const CLEAR_NOTIFICATION_CENTER_DATA = 'CLEAR_NOTIFICATION_CENTER_DATA'
export const TRANSFER_ROGUE_CLASSIFIED = 'TRANSFER_ROGUE_CLASSIFIED'
